//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * 地図表示なし
 */
export default function SetubiMapNone({ mainPole }) {
  const message = (mainPole && !mainPole.drawable())
      ? "代表電柱の座標が未登録のため地図を表示できません。"
      : "代表電柱が未設定のため地図を表示できません。";
  return (
    <Box
      align="center"
      color="grey.400"
      sx={{
        py: 3,
        border: 1,
        borderColor: 'grey.400',
      }}
    >
      <Typography variant="body2">{message}</Typography>
      <Typography variant="body2">
        共架申込基本情報画面に戻って代表電柱を選択してください。
      </Typography>
    </Box>
  );
}

// プロパティ
SetubiMapNone.propTypes = {
  mainPole: PropTypes.object,   // 代表電柱
};
